/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_View_MapInputs */

const vi_care_log_view_map = /** @type {(inputs: Care_Log_View_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem vùng trồng trên bản đồ`)
};

/**

* @param {Care_Log_View_MapInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_view_map = /** @type {((inputs?: Care_Log_View_MapInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_View_MapInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_view_map(inputs)
});